module.exports = __webpack_public_path__ + "img/xhs.e0217a05.png";